  // .00 を削除する関数
  function removeDecimalFromPrices() {
    document.querySelectorAll('.price-item').forEach(el => {
      const text = el.textContent;
      const match = text.match(/¥([\d,]+)\.00/);
      if (match) {
        el.textContent = `¥${match[1]}`;
      }
    });
  }

  // 商品カードのv-stackの高さを統一する関数（セクション別計算版）
  function alignProductCardVStacks() {
    const sections = document.querySelectorAll('section, .section');
    
    sections.forEach(section => {
      const productCards = section.querySelectorAll('.product-card');
      const vStacks = [];
      
      productCards.forEach(card => {
        const vStack = card.querySelector('.product-card__info > .v-stack');
        if (vStack && !vStack.dataset.heightCalculated) {
          vStacks.push(vStack);
        }
      });
      
      if (vStacks.length === 0) return;
      
      vStacks.forEach(vStack => {
        vStack.dataset.heightCalculated = 'true';
      });
      
      const originalHeights = new Map();
      vStacks.forEach(vStack => {
        originalHeights.set(vStack, vStack.style.minHeight);
        vStack.style.minHeight = '';
      });
      
      requestAnimationFrame(() => {
        let maxHeight = 0;
        
        vStacks.forEach(vStack => {
          const height = vStack.offsetHeight;
          if (height > maxHeight) {
            maxHeight = height;
          }
        });
        
        vStacks.forEach(vStack => {
          vStack.style.minHeight = `${maxHeight}px`;
        });
        
        console.log(`セクション内のv-stack高さを統一しました: ${maxHeight}px`);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // 初回実行
    removeDecimalFromPrices();
    alignProductCardVStacks();

    // DOM変化を監視
    const observer = new MutationObserver((mutations) => {
      let hasNewProductCards = false;
      
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.classList && node.classList.contains('product-card')) {
                hasNewProductCards = true;
                break;
              }
              if (node.querySelector && node.querySelector('.product-card')) {
                hasNewProductCards = true;
                break;
              }
            }
          }
        }
      }
      
      removeDecimalFromPrices();
      
      if (hasNewProductCards) {
        alignProductCardVStacks();
      }
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  });

  //PDFの外部リンク処理
function applyPdfExternalLinks(root = document) {
  const pdfPattern = /\.pdf(?:$|\?|#)/i;

  root.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href') || '';
    if (!pdfPattern.test(href)) return;

    if (!link.hasAttribute('target')) {
      link.setAttribute('target', '_blank');
    }
    if (!link.hasAttribute('rel')) {
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  removeDecimalFromPrices();
  alignProductCardVStacks();
  applyPdfExternalLinks();

  const observer = new MutationObserver(mutations => {
    let hasNewProductCards = false;

    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        applyPdfExternalLinks(node);

        if (node.classList?.contains('product-card') ||
            node.querySelector?.('.product-card')) {
          hasNewProductCards = true;
        }
      });
    });

    removeDecimalFromPrices();

    if (hasNewProductCards) {
      alignProductCardVStacks();
    }
  });

  observer.observe(document.body, { childList: true, characterData: true, subtree: true });
});